// removed by extract-text-webpack-plugin
module.exports = {"survey-search":"SurveySearchIcon__survey-search___2UTJD","search-icon":"SurveySearchIcon__search-icon___1PWOP"};